function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export const FlameIcon = (_0)=>{
    let { color = 'currentColor' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "18",
        height: "24",
        viewBox: "0 0 18 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5.4678 7.3947L5.46555 7.39653L5.46341 7.39861L5.4678 7.3947ZM15.4219 7.20817C15.3523 7.14111 15.2751 7.08244 15.1919 7.03336C15.0741 6.96402 14.9433 6.91958 14.8076 6.9028C14.672 6.88601 14.5343 6.89723 14.4031 6.93577C14.272 6.9743 14.1501 7.03933 14.0451 7.12683C13.9401 7.21433 13.8541 7.32245 13.7925 7.4445C13.448 8.12319 12.9729 8.72718 12.3945 9.22184C12.483 8.72344 12.5276 8.21825 12.5278 7.71207C12.5297 6.17217 12.1234 4.65928 11.3505 3.32743C10.5775 1.99558 9.4654 0.892354 8.12741 0.130066C7.98002 0.0465136 7.81382 0.00177616 7.6444 5.18089e-05C7.47498 -0.00167255 7.3079 0.0396727 7.15884 0.120208C7.00977 0.200744 6.88362 0.317829 6.7922 0.460477C6.70078 0.603125 6.6471 0.76666 6.6362 0.935736C6.58024 1.88391 6.33236 2.81085 5.90759 3.6604C5.48282 4.50995 4.88999 5.26442 4.16503 5.8781L3.93456 6.0656C3.17648 6.57569 2.50546 7.2045 1.94726 7.9279C1.07958 9.021 0.478506 10.3012 0.191718 11.6671C-0.0950709 13.0329 -0.0596893 14.4468 0.295056 15.7966C0.649802 17.1464 1.31415 18.3949 2.23543 19.4433C3.1567 20.4916 4.30956 21.3109 5.60257 21.8361C5.75439 21.8981 5.91914 21.9219 6.08229 21.9052C6.24545 21.8885 6.40198 21.8319 6.5381 21.7404C6.67422 21.6489 6.78573 21.5254 6.8628 21.3806C6.93987 21.2358 6.98013 21.0743 6.98003 20.9103C6.97932 20.8042 6.96252 20.6989 6.93023 20.5978C6.7065 19.7568 6.64208 18.8814 6.74028 18.0168C7.68652 19.8015 9.20542 21.2162 11.0528 22.0334C11.2783 22.1342 11.5332 22.1478 11.7681 22.0715C13.2277 21.6004 14.5425 20.7639 15.5878 19.6415C16.633 18.5191 17.3739 17.1481 17.74 15.6588C18.1061 14.1694 18.0853 12.6112 17.6796 11.1321C17.2739 9.65302 16.4967 8.30227 15.4219 7.20817ZM11.5171 20.0392C10.6454 19.5975 9.87649 18.9772 9.26028 18.2187C8.64406 17.4602 8.19438 16.5806 7.94046 15.6369C7.86291 15.3191 7.80293 14.9974 7.76077 14.673C7.73221 14.4665 7.63981 14.274 7.4965 14.1226C7.35318 13.9711 7.16612 13.8682 6.96146 13.8283C6.89841 13.8159 6.8343 13.8096 6.77003 13.8097C6.59427 13.8097 6.42161 13.856 6.26944 13.9439C6.11728 14.0319 5.991 14.1584 5.90333 14.3107C5.0736 15.7419 4.65633 17.3748 4.69776 19.0285C3.968 18.4611 3.35811 17.7545 2.90344 16.9497C2.44876 16.1449 2.15835 15.2578 2.04903 14.3399C1.93971 13.422 2.01366 12.4915 2.26658 11.6024C2.51951 10.7133 2.94639 9.88326 3.52247 9.16035C3.95989 8.59218 4.48756 8.09964 5.08447 7.70235C5.11032 7.68567 5.1351 7.6674 5.15869 7.64766C5.15869 7.64766 5.45538 7.40218 5.46552 7.39656C6.89022 6.19152 7.90353 4.57207 8.36426 2.76387C9.45383 3.7711 10.1804 5.1099 10.431 6.57238C10.6817 8.03485 10.4425 9.53918 9.75049 10.8518C9.65907 11.0269 9.62157 11.2252 9.64271 11.4216C9.66386 11.6181 9.74271 11.8039 9.86932 11.9555C9.99592 12.1072 10.1646 12.218 10.3541 12.2739C10.5436 12.3298 10.7454 12.3284 10.9341 12.2698C12.4659 11.7896 13.8138 10.8517 14.7964 9.58226C15.3869 10.4545 15.773 11.4489 15.9259 12.4911C16.0787 13.5334 15.9944 14.5967 15.6792 15.6018C15.364 16.6069 14.826 17.528 14.1054 18.2963C13.3847 19.0646 12.5 19.6604 11.5171 20.0393L11.5171 20.0392Z",
            fill: color
        })
    }));
};
